import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFunctions } from 'firebase/functions'
import { getStorage } from 'firebase/storage'
import { environment } from './environment'

// Initialize Firebase app using environment configuration
export const app = initializeApp(environment.getConfig().firebase)

// Initialize Firebase services
export const auth = getAuth(app)
export const functions = getFunctions(app, 'europe-west3')
export const storage = getStorage(app)

export default app